import { useEffect, useState } from 'react'
import { useParams } from '../Providers/ParamsProvider'
import LoadingSpinner from './Components/LoadingSpinner'
import { Licenses } from '../Data/Licenses.ts'

const MainThemeStylePicker = () => {
    const { license } = useParams()
    const [appVersion, setAppVersion] = useState(null)

    useEffect(() => {
        fetchVersion()
    }, [])

    useEffect(() => {
        if (!license || !appVersion) return

        let styleName = ''
        switch (license) {
            case Licenses.Ferrodo:
                styleName = 'FerrodoMainStyle.css'
                break
            case Licenses.TgInstalacje:
                styleName = 'TgMainStyle.css'
                break
            case Licenses.Hydraulik:
                styleName = 'HydraulikMainStyle.css'
                break
            case Licenses.Carmen:
                styleName = 'CarmenmainStyle.css'
                break
            default:
                styleName = 'FerrodoMainStyle.css'
        }

        const link = document.createElement('link')
        link.rel = 'stylesheet'
        link.type = 'text/css'
        link.href = `${process.env.PUBLIC_URL}/MainStyles/${styleName}?v=${appVersion}` //DK : dodajemu nr wersji aby zawsze po podbicu wersji pobierał nowy plik ze stylami!
        document.head.appendChild(link)

        // Style motywu muszą być OSTATNIE w <head>, bo nadpisują style bazowe (bootstrap,
        // DevExtreme, style stron). Przy lazy loadingu webpack dokleja arkusze CSS
        // doładowywanych stron na koniec <head> - bez tego wskoczyłyby ZA motyw
        // i nadpisały go (rozjechane tabele, filtry itd.).
        const keepThemeLast = new MutationObserver(() => {
            if (document.head.lastElementChild !== link) {
                document.head.appendChild(link) //przenosi istniejący element na koniec
            }
        })
        keepThemeLast.observe(document.head, { childList: true })

        return () => {
            keepThemeLast.disconnect()
            document.head.removeChild(link)
        }
    }, [license, appVersion])

    const fetchVersion = async () => {
        try {
            const response = await fetch('/version.json', { cache: 'no-cache' })
            const data = await response.json()
            setAppVersion(data.version)
        } catch {
            setAppVersion('1')
        }
    }

    if (!license || license.trim() === '') {
        return (
            <div style={{
                position: "fixed",
                top: 0, left: 0,
                width: "100vw", height: "100vh",
                zIndex: 9999,
                backgroundColor: 'white'
            }}>
                <LoadingSpinner fullScreenLoading={true} loadingText='Ładowanie motywu aplikacji...' />
            </div>
        )
    }
}

export default MainThemeStylePicker